import { RequiredKeysOf } from 'type-fest'
import { v4 as uuidv4 } from 'uuid'
import { OpalApiComponent, OpalApiRequestBody } from '../../schema'

type RequestAttributes =
  OpalApiRequestBody<'CreateBoardObjectCollectionV3'>['data']['attributes'] & {
    position: number
  }
type RequestRelationships =
  OpalApiRequestBody<'CreateBoardObjectCollectionV3'>['data']['relationships'] & {
    created_by_user: { data: { id: string; type: 'user' } }
  }

type OptionalAttributes = Omit<
  OpalApiComponent<'V3', 'board_object_collection'>['attributes'],
  RequiredKeysOf<RequestAttributes>
>

/**
 * Client-generated ids carry this prefix so optimistic UI can tell a
 * collection the API has never seen from one it has. Same convention as
 * `views/plans`.
 */
const CLIENT_RESOURCE_ID_PREFIX = 'temp-'

export function isClientResourceId(id: string) {
  return id.startsWith(CLIENT_RESOURCE_ID_PREFIX)
}

const defaultBoardAttributes: OptionalAttributes = {
  created_at: new Date().toISOString(),
  description: null,
  title: '',
  hide_empty_table: false,
  updated_at: new Date().toISOString(),
}

export function resourceObject({
  attributes,
  relationships,
}: {
  attributes: RequestAttributes
  relationships: RequestRelationships
}): OpalApiComponent<'V3', 'board_object_collection'> {
  return {
    id: `${CLIENT_RESOURCE_ID_PREFIX}${uuidv4()}`,
    type: 'board_object_collection',
    attributes: {
      ...defaultBoardAttributes,
      ...attributes,
    },
    relationships: {
      ...relationships,
    },
  }
}
